import React from 'react';
import { HTMLTable } from '@blueprintjs/core';
import get from 'lodash.get';

import CustomDataTable from './CustomDataTable';
import FieldDesc from './FieldDesc';

import styles from './ZoneDesc.module.scss';

const customizeTable = Component => props => (
  <Component
    bordered
    striped
    condensed
    style={{ width: '100%' }}
    {...props}
  />
);

const CustomHTMLTable = customizeTable(HTMLTable);

const ZoneSectionTableField = ({
  field,
  headers = [],
  zones = [],
  filters = [],
  title,
  transpose,
}) => {
  if (!headers.length || !zones.length || !field) {
    return null;
  }

  const [firstHeader] = headers;

  // Merge rows of multiples zones
  const tableRows = zones
    .reduce((acc, { [field]: rows = [], color }) => (
      Array.isArray(rows)
        ? [...acc, ...rows.map(row => ({ ...row, color }))]
        : acc
    ), [])
    .filter(row => (
      filters.length
        ? filters.every(filter => get(row, filter))
        : true
    ));

  try {
    tableRows.sort((
      { [firstHeader]: a },
      { [firstHeader]: b },
    ) => (a || '').localeCompare(b || ''));
  } catch (e) {
    console.error(`Unable to sort with "${firstHeader}"`, e);
  }

  if (!tableRows.length) {
    return null;
  }

  if (transpose) {
    return (
      <>
        {title && <h2>{title}</h2>}

        {zones.map(zone => (
          <React.Fragment key={zone.nom_ppal}>
            {Boolean(zones.length > 1) && <h3>{zone.nom_ppal}</h3>}

            {zone[field].map(fieldEntry => (
              <CustomDataTable
                key={JSON.stringify(fieldEntry)}
                fields={headers}
                zones={[fieldEntry]}
                fluid
              />
            ))}
          </React.Fragment>
        ))}
      </>
    );
  }

  return (
    <>
      {title && <h2>{title}</h2>}

      <CustomHTMLTable className={styles.table}>
        <thead>
          <tr>
            {headers.map(header => (
              <th key={header}>
                <FieldDesc field={header} />
              </th>
            ))}
          </tr>
        </thead>

        <tbody className={styles.tbody}>
          {tableRows.map(row => (
            <tr key={JSON.stringify(row)}>
              {headers.map(header => (
                <td
                  key={header}
                  style={{ borderLeft: `1px solid ${row.color}` }}
                >
                  {row[header]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </CustomHTMLTable>
    </>
  );
};

export default ZoneSectionTableField;
